import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "answer",
    "buttonLabel",
    "toggleButton",
    "worksheet",
    "worksheetButton",
    "worksheetButtonLabel",
  ]

  toggle() {
    this.toggleAnswer()
  }

  toggleAnswer() {
    const answer = this.answerTarget
    const hidden = answer.classList.toggle("hidden")

    answer.hidden = hidden

    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.setAttribute("aria-expanded", (!hidden).toString())
    }

    if (this.hasButtonLabelTarget) {
      this.buttonLabelTarget.textContent = hidden
        ? "Show example answer"
        : "Hide example answer"
    }
  }

  toggleWorksheet() {
    if (!this.hasWorksheetTarget) return

    const worksheet = this.worksheetTarget
    const hidden = worksheet.classList.toggle("hidden")

    worksheet.hidden = hidden

    if (this.hasWorksheetButtonTarget) {
      this.worksheetButtonTarget.setAttribute("aria-expanded", (!hidden).toString())
    }

    if (this.hasWorksheetButtonLabelTarget) {
      this.worksheetButtonLabelTarget.textContent = hidden
        ? "Open worksheet"
        : "Hide worksheet"
    }
  }
}
